import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { newsList } from "@/mocks/news";
import { formatDate, getDramaTitle } from "@/utils/content";
import type { NewsItem } from "@/types/content";

const items = newsList as NewsItem[];

export default function NewsSection() {
  const [featured, ...rest] = items;

  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
      <SectionHeading
        eyebrow="资讯速递"
        title="最新影视资讯"
        description="按时间为你整理近期影视动态，第一时间了解新剧上线、口碑与话题。"
        action={{ label: "查看全部影视", to: "/category" }}
      />

      <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
        <Link
          to={`/detail/${featured.dramaId}`}
          className="group relative overflow-hidden rounded-lg border border-background-200 bg-foreground-950"
        >
          <div className="w-full aspect-[16/10] lg:aspect-[16/12]">
            <img
              src={featured.cover}
              alt={featured.title}
              title={featured.title}
              className="w-full h-full object-cover object-top opacity-90 transition-transform duration-500 group-hover:scale-105"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/35 to-transparent" />
          <div className="absolute inset-x-0 bottom-0 p-5 md:p-6">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-background-50">
              {featured.tag}
            </span>
            <h3 className="mt-3 font-heading text-xl md:text-2xl font-bold text-white leading-snug">
              {featured.title}
            </h3>
            <p className="mt-2 text-sm text-white/80 line-clamp-2 leading-relaxed">{featured.summary}</p>
            <p className="mt-3 text-xs text-white/60">
              {formatDate(featured.date)} · 关联剧集《{getDramaTitle(featured.dramaId)}》
            </p>
          </div>
        </Link>

        <div className="flex flex-col gap-3">
          {rest.map((item) => (
            <Link
              key={item.id}
              to={`/detail/${item.dramaId}`}
              className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-accent-300"
            >
              <div className="w-24 sm:w-28 shrink-0 overflow-hidden rounded-md bg-background-200">
                <div className="w-full aspect-[4/3]">
                  <img
                    src={item.cover}
                    alt={item.title}
                    title={item.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
              </div>
              <div className="min-w-0 flex-1">
                <span className="inline-block rounded bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
                  {item.tag}
                </span>
                <h3 className="mt-1.5 font-heading text-sm md:text-base font-semibold text-foreground-950 line-clamp-2 group-hover:text-accent-600 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-1 hidden sm:block text-xs text-foreground-500 line-clamp-1">{item.summary}</p>
                <p className="mt-1 text-xs text-foreground-400">{formatDate(item.date)}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}